import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export type AiOrderType = 'SALES_ORDER' | 'PURCHASE_ORDER';

export interface AiParsedOrderLine {
    lineNumber?: number | null;
    itemCode?: string | null;
    productCode?: string | null;
    description?: string | null;
    unitOfMeasure?: string | null;
    quantity?: number | null;
    unitPrice?: number | null;
    taxRate?: number | null;
    netAmount?: number | null;
    taxAmount?: number | null;
    grossAmount?: number | null;
    lineTotal?: number | null;
}

export interface AiParsedOrderDocument {
    source?: string;
    fileName?: string;
    orderType?: AiOrderType;
    documentType?: string | null;
    documentStatus?: string | null;
    documentNumber?: string | null;
    counterpartyName?: string | null;
    supplierName?: string | null;
    buyerName?: string | null;
    billToName?: string | null;
    contactName?: string | null;
    contactEmail?: string | null;
    contactPhone?: string | null;
    orderDate?: string | null;
    expectedDate?: string | null;
    paymentTerms?: string | null;
    currencyCode?: string | null;
    shippingAddress?: string | null;
    billingAddress?: string | null;
    subtotalAmount?: number | null;
    taxAmount?: number | null;
    totalAmount?: number | null;
    notes?: string | null;
    warnings?: string[];
    lines?: AiParsedOrderLine[];
}

@Injectable({ providedIn: 'root' })
export class OrderDocumentAiService {
    private readonly baseUrl = `${environment.aiServiceApiUrl}order-documents`;

    constructor(private readonly http: HttpClient) {
    }

    extract(file: File, orderType: AiOrderType): Observable<AiParsedOrderDocument> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('orderType', orderType);
        return this.http.post<AiParsedOrderDocument>(`${this.baseUrl}/extract`, formData);
    }
}
